module.exports = __webpack_public_path__ + "img/logo.fbe3018a.png";